module.exports = __webpack_public_path__ + "static/media/setting_logo.115e45bf.svg";